import * as Sentry from "@sentry/react";

// Browser error tracking. Reports to the self-hosted GlitchTip project
// `codessa-cloud` (https://errors.logic-leap.co.uk). No-ops without
// VITE_SENTRY_DSN, so local development and tests send nothing. The DSN is a
// plain Workers Builds variable baked in at build time.
const dsn = import.meta.env.VITE_SENTRY_DSN?.trim();

export function initObservability(): void {
  if (!dsn) return;
  Sentry.init({
    dsn,
    environment: import.meta.env.VITE_SENTRY_ENVIRONMENT?.trim() || import.meta.env.MODE,
    release: import.meta.env.VITE_COMMIT_SHA?.trim() || undefined,
    sendDefaultPii: false,
    tracesSampleRate: 0,
    // Console breadcrumbs can carry relay and session payloads.
    beforeBreadcrumb: (breadcrumb) => (breadcrumb.category === "console" ? null : breadcrumb),
    beforeSend: (event) => {
      if (event.request) {
        delete event.request.data;
        delete event.request.cookies;
      }
      return event;
    },
  });
}
